import { DateRangeValue } from "../../../../store/principal";

export const CUSTOME: DateRangeValue = "custom";
